import Sidebar from "@/components/Sidebar";
import { useUser } from "@/contexts/UserContext";

export default function MainLayout({ children, title, subtitle, headerActions }) {
  const { user, loading } = useUser();
  
  // Default to viewer role (most restrictive) while loading
  const userRole = loading ? "viewer" : (user?.role || "viewer");
  
  return (
    <div className="min-h-screen bg-[#0a0a0f] flex">
      <Sidebar userRole={userRole} />
      <main className="flex-1 overflow-auto">
        {(title || headerActions) && (
          <header className="bg-[#12121a]/80 backdrop-blur-xl border-b border-white/5 sticky top-0 z-40">
            <div className="px-8 py-4 flex items-center justify-between">
              <div>
                {title && <h2 className="text-2xl font-bold text-white">{title}</h2>}
                {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
              </div>
              {headerActions && (
                <div className="flex items-center gap-4">
                  {headerActions}
                </div>
              )}
            </div>
          </header>
        )}
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
  );
}
